import React from 'react';

const AWS_Budgets = () => {
  return (
    <div>
      <h1>AWS_Budgets</h1>
      <p>This is the AWS_Budgets component.</p>
    </div>
  );
};

export default AWS_Budgets;
